module.exports = __webpack_public_path__ + "static/media/dplus.97ffa133.png";